import { frontendURL } from '../../../helper/URLHelper';
import { FEATURE_FLAGS } from '../../../featureFlags';
import ContractsList from './ContractsList.vue';
import ContratoDetail from './ContratoDetail.vue';
import Deuda from './Deuda.vue';
import Lecturas from './Lecturas.vue';

const commonMeta = {
  featureFlag: FEATURE_FLAGS.CONTRACTS,
  permissions: ['administrator', 'agent'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/contracts'),
    name: 'contracts_list',
    component: ContractsList,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/contracts/:contratoId'),
    name: 'contract_detail',
    component: ContratoDetail,
    props: true,
    meta: commonMeta,
  },
  {
    path: frontendURL(
      'accounts/:accountId/contracts/:contratoId/deuda/:explotacion'
    ),
    name: 'contract_deuda',
    component: Deuda,
    props: true,
    meta: commonMeta,
  },
  {
    path: frontendURL(
      'accounts/:accountId/contracts/:contratoId/lecturas/:explotacion'
    ),
    name: 'contract_lecturas',
    component: Lecturas,
    props: true,
    meta: commonMeta,
  },
];

export default routes;
